//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import access from "config/access";
import Table from "components/Table/Table";
import Loader from "components/Loader/Loader";

// custom pages
import { mpcDetailStyles } from "./styles";
import negativePoints from "apis/negativePoints/negativePoints";
import Context from "context/context";
import { dateFormat } from "helpers/dataFormat"
import { useTranslation } from 'react-i18next';
// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
// material-ui icons
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import { pointsFormat, currencyFormat, tierRatioFormat } from "helpers/dataFormat";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import HistoryIcon from "@material-ui/icons/History";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HistoryTable from "components/Table/History/HistoryTable";



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const sendEmailTransition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});


// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function ViewShipTo(props) {
  const { state, dispatch } = useContext(Context);
  const { negativdetails, getHistoryApi, sendEmail } = negativePoints();
  const history = useHistory();
  const location = useLocation();
  const classes = mpcDetailStyles();
  const [mpc, setMpc] = useState({});
  const [data, setData] = useState([]);
  const [balance, setBalance] = useState();
  const [emailPopOpen, setEmailPopOpen] = useState(false);
  const [emailHistoryPopOpen, setEmailHistoryPopOpen] = useState(false);


  const [count, setCount] = useState(1);
  const [offset, setOffset] = useState(1);

  const [dataClone, setDataClone] = useState({});
  const [updated, setUpdated] = useState({});
  const [edit, setEdit] = useState(false);
  const { t, i18n } = useTranslation();
  const [mailType, setMailType] = useState('');
  const [sendButton, setSendButton] = useState("Send");
  const [dropDownErrorText, setDropDownErrorText] = useState("");
  const [loyaltyData, setLoyaltyData] = useState();
  const [states, setstates] = useState({
    historyLoader: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;



  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Negative Detail"],
    });
  }, []);

  // handling api calls
  useEffect(() => {


    if (location?.state?.loyaltyId?.loyalty_id) {
      setLoyaltyData(location?.state?.loyaltyId);
      handleGet();
      return;
    }
    history.goBack();
  }, [offset]);

  const handlePagination = (value) => {
    setOffset(value);
  };
  // authorized members api func
  const handleGet = async () => {
    try {
      let id = location?.state?.loyaltyId?.loyalty_id;

      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
        id: id
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await negativdetails(values);
      if (res) {
        setData(res?.data);
        setDataClone(res?.data[0]);
        setCount(res?.count);
        // setBalance(res?.currentBalance)
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };
  const handleSendEmail = async (id) => {
    try {
      let values;
      let mailType;
      if (location?.state?.loyaltyId?.negative_count > 60 && location?.state?.loyaltyId?.negative_count <= 90) {
        mailType = "NEGATIVE_POINTS_NOTIFICATION_SIXTIETH_DAY"
      }
      if (location?.state?.loyaltyId?.negative_count > 90 && location?.state?.loyaltyId?.negative_count < 180) {
        mailType = "NEGATIVE_POINTS_NOTIFICATION_NINETIETH_DAY"
      }
      values = {
        loyaltyId: id,
        email_type: mailType,
        negative_count: location?.state?.loyaltyId?.negative_count
      };

      let res = await sendEmail(values);


      if (res) {
        if (res.type === "success") {
          setMailType("")

          history.push("/dashboard/upload-success", {
            type: i18n.language == 'fr' ? res.french_message : res.message,
          });
        } else {
          return toast.error(i18n.language == 'fr' ? res.french_message : res.message);
        }
      }
    } catch (e) {
      console.log({ e });
    }
  };
  const handleGetSendbutton = async (id, screenName) => {
    try {
      let values;
      let mailType = '';
      if (location?.state?.loyaltyId?.negative_count > 60 && location?.state?.loyaltyId?.negative_count <= 90) {
        mailType = "NEGATIVE_POINTS_NOTIFICATION_SIXTIETH_DAY"
      }
      if (location?.state?.loyaltyId?.negative_count > 90 && location?.state?.loyaltyId?.negative_count < 180) {
        mailType = "NEGATIVE_POINTS_NOTIFICATION_NINETIETH_DAY"
      }

      if (id) {
        values = {
          loyaltyId: id,
          screen: screenName,
          type: mailType
        };
      }

      let res = await getHistoryApi(values);
      if (res && res.data.length > 0) {
        setSendButton("ReSend")
        setStates({ historyData: res?.data, historyLoader: false });

      } else {
        setSendButton("Send")
        setStates({ historyData: res?.data, historyLoader: false });



      }
    } catch (e) {
      console.log({ e });
      setSendButton("Send")

    }
  };








  return (
    <React.Fragment>
      <Grid container style={{ padding: 10 }}>
        <Grid item xs={4}>
          <Button
            className={classes.editBtn}
            onClick={() => {
              history.push("/dashboard/negativepoints",);
            }}
          >
            Back
          </Button>
        </Grid>
        {/* {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" &&
          <Grid item xs={4}>
            <Button
              disabled={location?.state?.loyaltyId?.negative_count <= 60}

              className={location?.state?.loyaltyId?.negative_count <= 60 ? classes.sendEmailBtnDisable : classes.editBtn}
              onClick={() => {
                setEmailPopOpen(true)
                
                handleGetSendbutton(location?.state?.loyaltyId?.loyalty_id, 'Button')


              }}
            >
             
              Send Email
            </Button>
          </Grid>} */}
        {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" &&
          <Grid item xs={8}>
            <Button
              // disabled={location?.state?.loyaltyId?.negative_count <= 60}

              className={classes.editBtn}
              onClick={() => {
                setEmailHistoryPopOpen(true)
                //   setData(p)
                //   setMailType("");
                setStates({ historyLoader: true });
                handleGetSendbutton(location?.state?.loyaltyId?.loyalty_id, 'History')


              }}
            >
              {/* {p?.new_type?'Resend Email':'Send Email'} */}
              <HistoryIcon />
              Email History
            </Button>
          </Grid>}

      </Grid>

      <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>Negative Balance Details</div>
        </div>


        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Loyalty ID</span> :{" "}
            {location?.state?.loyaltyId?.loyalty_id}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Billto</span> :{" "}
            {location?.state?.loyaltyId?.customer_billto_account_number}
          </div>
        </Grid>

        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Current Balance</span> :{" "}
            {pointsFormat(location?.state?.loyaltyId?.points_balance, i18n.language)}
          </div>

        </Grid>

        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Consecutive Negative (days)</span> :{" "}
            {location?.state?.loyaltyId?.negative_count}
          </div>

        </Grid>
      </Grid>
      <Loader loading={state.loading} top="15%">
        <Grid className={classes.tableDownInResponsive}>
          <Grid item xs={12} sm={12} lg={12}>
            {data ? (
              <Table
                headings={[
                  "Loyalty Id",
                  "Billto",
                  "Negative Points",
                  "Date Log"
                ]}
                data={
                  data &&
                  data?.length > 0 &&
                  data?.map((d, i) => [
                    d?.Loyalty_id,
                    d?.customer_billto_account_number,
                    pointsFormat(d?.Negative_points, i18n.language),
                    dateFormat(d?.Negative_Date, i18n.language)

                  ])
                }
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 120)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            ) : (
              <Loader Loading={true} top={"15%"} />
            )}
          </Grid>
        </Grid>
      </Loader>


      {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" && <Loader loading={state?.loading}>
        <Dialog
          open={emailPopOpen}
          TransitionComponent={sendEmailTransition}
          keepMounted
          onClose={() => setEmailPopOpen(false)}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <span
                style={{ float: "right", color: "red", cursor: "pointer", fontSize: 20 }}
                onClick={() => {
                  setMailType("");
                  setSendButton("Send")
                  setEmailPopOpen(false);
                }}
              >
                X
              </span>
              <h1 style={{ textAlign: "center" }}>{t('Send Email')}</h1>
              <div style={{ fontSize: 16, color: "#000", padding: "20px" }}>
                <Grid container>

                  <Grid xs={12} lg={6} className={classes.grid}>
                    <div>
                      <span className={classes.gridSpan}>Loyalty Id</span> :{" "}
                      {location?.state?.loyaltyId.loyalty_id}
                    </div>

                  </Grid>
                  <Grid xs={12} lg={6} className={classes.grid}>
                    <div>
                      <span className={classes.gridSpan}>Billto</span> :{" "}
                      {location?.state?.loyaltyId.customer_billto_account_number}

                    </div>
                  </Grid>


                  <Grid xs={12} lg={6} className={classes.grid}>
                    <div>
                      <span className={classes.gridSpan}>Points Balance</span> :{" "}
                      {pointsFormat(location?.state?.loyaltyId.points_balance, i18n.language)}

                    </div>
                  </Grid>

                  <Grid xs={12} lg={6} className={classes.grid}>

                    <div>
                      <span className={classes.gridSpan}>Email Type</span> :{" "}
                      {location?.state?.loyaltyId?.negative_count > 60 && location?.state?.loyaltyId?.negative_count <= 90 && t('60th Day Email')}
                      {location?.state?.loyaltyId?.negative_count > 90 && location?.state?.loyaltyId?.negative_count < 180 && t('90th Day Email')}
                    </div>
                  </Grid>
                  <Grid xs={12} lg={8} className={classes.grid}>

                    <div>
                      <span className={classes.gridSpan}>Consecutive Negative (days)</span> :{" "}
                      {location?.state?.loyaltyId.negative_count}
                    </div>
                  </Grid>
            



                </Grid>
                {sendButton?.toLowerCase() == 'send' ?

                  <div style={{ textAlign: "center" }}>
                    <button
                      className={classes.cancelBtn}
                      onClick={() => {

                        setEmailPopOpen(false)
                        setMailType("")
                        setSendButton("Send")
                      }}
                    >
                      {t('Cancel')}
                    </button>

                    <button
                      className={classes.sendBtn}
                      onClick={() => {
                        // if(mailType==''){
                        //   toast.error("Please select Email Type");
                        //   return;
                        // }
                        handleSendEmail(location?.state?.loyaltyId?.loyalty_id)
                        setSendButton("Send")
                      }}

                    // disabled={!access['editAccess'][state.userInfo?.role]['email-logs']}
                    >
                      {t('Send')}
                      {/* {t(sendButton)}  */}
                    </button>
                  </div>
                  : <p className={classes.emailNoteText}> <span style={{ color: "red" }}> {location?.state?.loyaltyId?.negative_count > 60 && location?.state?.loyaltyId?.negative_count <= 90 && t('60th Day Email is Already Sent')}
                  {location?.state?.loyaltyId?.negative_count > 90 && location?.state?.loyaltyId?.negative_count < 180 && t('90th Day Email is Already Sent')}</span></p>}
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>

      </Loader>}
      {/* Audit Logs Dialog */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={emailHistoryPopOpen}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {t('History')}{" "}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setEmailHistoryPopOpen(false)
                }}
              />
            </span>
          </div>
          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Loyalty Id",
                "Email Type",
                "Date At",
                "Email Initiated By"
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.loyalty_id,
                  d?.email_type=='NEGATIVE_POINTS_NOTIFICATION_NINETIETH_DAY'?'90th Day Email': d?.email_type=='NEGATIVE_POINTS_NOTIFICATION_SIXTIETH_DAY'?'60th Day Email':'Day 1 Email',
                  d?.run_date,
                  d?.email
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>


    </React.Fragment>
  );
}
